<template>
    <div class="flex flex-col desktop:flex-row">
        <div class="form-box w-full desktop:w-1/2 p-8">
            <h2 class="!text-xl !font-bold">{{ $t('blog.owners.simulate-income') }}</h2>
            <p class="font-bold mt-10">{{ $t('blog.owners.select-aircraft-type') }}</p>
            <form-select class="mt-6 w-72 h-10 rounded-sm max-w-full" v-model="selectedPlaneModelId" :items="planeModels" item-value="id" item-text="name" />
            <p class="text-xs mt-8">
                {{ $t('blog.owners.footnote', {pricePerHour: selectedPlaneModel.hourPrice}) }}
            </p>
        </div>
        <div class="result-box w-full desktop:w-1/2 relative">
            <div class="absolute bg-white income-box">
                <div class="income">{{ $t('blog.owners.income-by-year', {income}) }}</div>
                <div class="income-info">{{ $t('blog.owners.income-info') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import FormSelect from './Select.vue';

export default {
    components: {
        FormSelect,
    },

    data() {
        return {
            planeModels: [
                {
                    id: 1,
                    name: 'Cirrus SR-22',
                    hourPrice: 420,
                },
                {
                    id: 2,
                    name: 'Piper PA-32',
                    hourPrice: 510,
                },
                {
                    id: 3,
                    name: 'Piper Mirage',
                    hourPrice: 590,
                },
                {
                    id: 4,
                    name: 'Diamond DA-62',
                    hourPrice: 650,
                },
                {
                    id: 5,
                    name: 'Piper Meridian M500',
                    hourPrice: 900,
                },
                {
                    id: 6,
                    name: 'Daher TBM 850',
                    hourPrice: 1100,
                },
            ],
            selectedPlaneModelId: 5,
        };
    },

    computed: {
        selectedPlaneModel() {
            return this.planeModels.find((m) => m.id == this.selectedPlaneModelId);
        },

        income() {
            return this.selectedPlaneModel.hourPrice * 150;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~styles/_variables';
.form-box {
    @media (min-width: $desktop-bottom-breakpoint) {
        height: 500px;
    }
    background-image: linear-gradient(135deg, $primary-color 0%, $primary-color-dark 100%);
    color: white;
    select {
        background-color: #FFFFFF00;
        border: solid 1px white;
    }
}
.result-box {
    background: url('/imgs/owners/income-simulator.webp');
    background-size: cover;
    @media (min-width: $desktop-bottom-breakpoint) {
        height: 500px;
    }
    @media (max-width: $mobile-top-breakpoint) {
        height: 400px;
    }
    .income-box {
        bottom: 30px;
        right: 30px;
        left: 30px;
        padding: 30px;
        .income {
            color: $primary-color;
            font-size: 28px;
            font-weight: bold;
            @media (max-width: $mobile-top-breakpoint) {
                font-size: 20px;
            }
        }
        .income-info {
            font-weight: bold;
            margin-top: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/OwnerIncomeSimulator.vue